var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      ref: "picker",
      attrs: {
        "close-on-content-click": false,
        "nudge-right": 10,
        "nudge-top": 0,
        lazy: "",
        transition: "scale-transition",
        "offset-y": "",
        "full-width": "",
        "min-width": "290px"
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "InputField",
                _vm._g(
                  {
                    attrs: { label: _vm.label, readonly: "" },
                    model: {
                      value: _vm.date,
                      callback: function($$v) {
                        _vm.date = $$v
                      },
                      expression: "date"
                    }
                  },
                  on
                )
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.picker,
        callback: function($$v) {
          _vm.picker = $$v
        },
        expression: "picker"
      }
    },
    [
      _vm._v(" "),
      _c("v-date-picker", {
        attrs: { color: "green", "no-title": "", scrollable: "" },
        on: {
          input: function($event) {
            return _vm.close()
          }
        },
        model: {
          value: _vm.date,
          callback: function($$v) {
            _vm.date = $$v
          },
          expression: "date"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DatePicker.vue?vue&type=template&id=a76e93e8&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&
// module id = null
// module chunks = 